import { checkPreviewIsAvailable } from "@/shared/form/button/document-button/model/check-preview-is-available";
import { DocViewerFileFragment } from "gql/graphql";

export function useDocumentPreview({
  temporaryLink,
  fileName,
}: DocViewerFileFragment) {
  const uri = temporaryLink
    ? `${window.location.origin}${temporaryLink}`
    : null;
  const isPreviewAvailable = checkPreviewIsAvailable(fileName);

  return {
    uri,
    isPreviewAvailable,
  };
}
